import React, { useEffect } from "react";
import Sidebar from "../../components/common/Sidebar";
import RodeoEventPerformancePage from "../../components/events/rodeoEventPerformance/rodeoEventPerformancePage";
import { APPLICATION_NAME, RODEO_PAGE_NAME } from "../../_config";

export default function RodeoEventPerformanceContainer() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : Days List`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <React.Fragment>
      <Sidebar page={RODEO_PAGE_NAME.PERFORMANCE_LIST} />
      <section className="main-container">
        <RodeoEventPerformancePage />
      </section>
    </React.Fragment>
  );
}
